// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"41dcd133","20":"7a812f13","72":"7a812f13","223":"7a812f13","238":"71a2991c","461":"7a812f13","479":"acd8ad4c","529":"7a812f13","885":"7a812f13","963":"7a812f13"}[chunkId] + ".chunk.css";
};